import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, X } from "lucide-react";
import { useT } from "../lib/i18n";

const KEY = "cf_guided_return";

// Called by guided workspaces (Night/Morning Ops) before navigating into a step.
export function setGuidedReturn(to, label, routes) {
  try { localStorage.setItem(KEY, JSON.stringify({ to, label, routes })); } catch (e) { /* ignore */ }
}

export default function GuidedReturnBanner() {
  const { t } = useT();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [ctx, setCtx] = useState(null);

  useEffect(() => {
    let g = null;
    try { g = JSON.parse(localStorage.getItem(KEY) || "null"); } catch (e) { g = null; }
    if (!g) { setCtx(null); return; }
    if (pathname === g.to) { localStorage.removeItem(KEY); setCtx(null); return; }
    const onStep = (g.routes || []).some((r) => pathname === r || pathname.startsWith(r + "/"));
    if (onStep) setCtx(g);
    else { localStorage.removeItem(KEY); setCtx(null); }
  }, [pathname]);

  if (!ctx) return null;
  const back = () => { localStorage.removeItem(KEY); navigate(ctx.to); };
  const dismiss = () => { localStorage.removeItem(KEY); setCtx(null); };

  return (
    <div data-testid="guided-return-banner"
      className="mb-4 flex items-center gap-3 rounded-2xl border border-primary-light bg-primary-light/60 px-4 py-2.5">
      <button onClick={back} data-testid="guided-return-btn"
        className="inline-flex shrink-0 items-center gap-1.5 rounded-xl bg-primary px-3 py-1.5 text-sm font-bold text-white transition hover:opacity-90">
        <ArrowLeft size={15} /> {t("Back to")} {t(ctx.label)}
      </button>
      <p className="flex-1 text-xs text-ink-soft">{t("Finish this task, then continue your guided flow.")}</p>
      <button onClick={dismiss} data-testid="guided-return-dismiss" className="shrink-0 text-ink-mute hover:text-ink">
        <X size={16} />
      </button>
    </div>
  );
}
